import { HelpCircle } from "lucide-react";

import { StatementList } from "@/app/common/components/composite/list/StatementList";

export type QuestionListProps = {
  items: readonly string[];
  ariaLabel?: string;
};

/** The questions a reader brings to a capability, as prompts, not links. */
export function QuestionList({ items, ariaLabel }: QuestionListProps) {
  return (
    <StatementList items={items} icon={HelpCircle} ariaLabel={ariaLabel} />
  );
}
